import { Avatar, Dialog, Rating } from "@mui/material";
import React, { useState } from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import instagram from "../assets/images/instagram.png";
import youtube from "../assets/images/youtube.png";
import tiktok from "../assets/images/tik-tok.png";
import linkd from "../assets/images/linkedin.png";
import facebook from "../assets/images/facebook.png";
const ViewExpertDetailsModal = ({
    Open,
    setOpen,
    user,

}) => {
    const [isReadMore, setIsReadMore] = useState(false);

    const handleclose = () => {
        setOpen(false);
    };
    const handleReadMoreToggle = () => {
        setIsReadMore((prev) => !prev);
    };

    const isTextLong = user?.about?.length > 190;


    return (
        <>
            <Dialog
                open={Open}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "370px",
                    },
                }}
            >

                <div className="overflow-y-auto">
                    <div className="w-full  bg-white rounded-2xl p-7 ">
                        <div className="flex flex-col justify-center gap-5">
                            <div
                                className="cursor-pointer flex justify-end"
                                onClick={handleclose}
                            >
                                <RiCloseLargeFill size={14} />
                            </div>

                            <div className="w-full flex justify-center flex-col gap-5">
                                <div className="flex flex-col gap-2">
                                    <div
                                        className="bg-white rounded-full p-[2px] mx-auto "
                                        style={{
                                            boxShadow: " rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                        }}
                                    >
                                        <Avatar
                                            src={
                                                user?.profileImage
                                            }
                                            alt="man"
                                            className="object-cover rounded-full !h-[90px] !w-[90px] mx-auto"
                                        />
                                    </div>
                                    <div className="text-center font-bold ">
                                        {user?.first_name} {user?.last_name}
                                    </div>
                                    <div className="  flex flex-col gap-5 w-full">

                                        <div className="justify-center flex flex-row flex-wrap gap-6">
                                            <Rating
                                                sx={{ color: "#FFD700" }}
                                                defaultValue={user?.avg_rating}
                                                size="20"
                                                precision={0.5}
                                                name="half-rating-read"
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <span className="font-[600]">About</span>
                                    <div className="text-[15px]">
                                       
                                        {isTextLong && !isReadMore
                                            ? user?.about?.substring(0, 190)
                                            : user?.about}

                                        {isTextLong && (
                                            <span
                                                onClick={handleReadMoreToggle}
                                                className="text-[#EF5a24] font-[500]  text-[14px] cursor-pointer pl-2"
                                            >
                                                {isReadMore ? "Read Less" : "Read More"}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex gap-4 flex-wrap items-center py-1">
                                    <a href={user?.linkedinProfile}>
                                        <img src={linkd} alt="linkedin" width={17} />
                                    </a>
                                    <a href={user?.youtubeProfile}>
                                        <img src={youtube} alt="youtube" width={20} />
                                    </a>
                                    <a href={user?.instagramProfile}>
                                        <img src={instagram} alt="instagram" width={18} />
                                    </a>
                                    <a href={user?.facebookProfile}>
                                        <img src={facebook} alt="facebook" width={9} />
                                    </a>
                                    <a href={user?.tiktokProfile}>
                                        <img src={tiktok} alt="tik" width={18} />
                                    </a>
                                </div>
                                <div className="border-[1px] border-[#EDEDED] rounded-[5px] p-[10px] flex flex-col gap-2">

                                    <div className="flex sm:items-center sm:justify-between  sm:flex-row flex-col">
                                        <span className="font-[600] text-[#0C0C0c] text-[15px] ">
                                            Country:
                                        </span>
                                        <span className="break-words text-[14px]">
                                            {user?.country}
                                        </span>
                                    </div>
                                    <div className=" flex items-center justify-between text-[15px]">
                                        <span className="font-[600] text-[#0C0C0c]">
                                            Phone:
                                        </span>
                                        <span className="text-[#0C0C0c] text-[14px]">
                                            <b> +{user?.code}</b>{" "}{user?.phone}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </Dialog>
        </>
    );
};

export default ViewExpertDetailsModal;
